import React from 'react';
import {useToggleCart} from "../model/useToggleCart";
import {GoodsType} from "../../../../entities/goods/model/types/goods-type";
import IconBasket from "../../../../shared/ui/icons/icon-basket.ui";
import Button from "../../../../shared/ui/button/Button";
import styled from "styled-components";
import {GLOBAL_STYLE_CONFIG} from "../../../../app/styles/GlobalStyles";

const StyledButton = styled(Button)`

    svg path {
        stroke: var(${GLOBAL_STYLE_CONFIG.variable('button', 'text-color')}, white);
    }

    &.is-in-cart {
        background-color: transparent;
        border: 1px solid var(${GLOBAL_STYLE_CONFIG.variable('button', 'bg-color')}, ${({theme}) => theme.colors.primary});

        svg path {
            stroke: var(${GLOBAL_STYLE_CONFIG.variable('button', 'hover-text-color')},
            ${({theme}) => theme.colors.primary});
        }
    }

`

interface IProps {
    goods: GoodsType
}

/**
 * Компонента, отвечающая за жизненный цикл товара в корзине.
 * - Инкапсулирует логику добавления/удаления товара через useToggleCart
 * - Управляет состоянием кнопки, проверяя наличие товара в корзине (isInCart)
 *
 * @param {GoodsType} goods - объект товара
 * @returns {JSX.Element}
 */

const ToggleCartButton: React.FC<IProps> = ({goods}) => {
    const {isInCart, toggle} = useToggleCart(goods);
    const onToggleHandler = (e: React.MouseEvent<HTMLButtonElement>) => {
        e.preventDefault();
        e.stopPropagation();
        toggle();
    }
    const classname =`${GLOBAL_STYLE_CONFIG.splitByPrefix('card-add-to-cart')} ${isInCart ? 'is-in-cart' : ''}`;
    return (
        <StyledButton onClick={onToggleHandler} className={classname}>
            <IconBasket/>
        </StyledButton>
    );
};

export default ToggleCartButton;